/** Small per-email photo map. Kept apart from the large settings blob so a
 * profile save still shows on this browser's people list. */

const STORAGE_KEY = 'demandjet.profilePhotos';

function readAll() {
  if (typeof localStorage === 'undefined') return {};
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

function writeAll(all) {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
}

export function lookupProfilePhoto(email) {
  const key = String(email || '').trim().toLowerCase();
  if (!key) return '';
  return String(readAll()[key] || '').trim();
}

/** Remember a photo, or clear it when the saved value is empty. */
export function rememberProfilePhoto(email, avatarDataUrl) {
  const key = String(email || '').trim().toLowerCase();
  if (!key) return '';
  const all = readAll();
  const photo = String(avatarDataUrl || '').trim();
  if (photo) all[key] = photo;
  else delete all[key];
  try {
    writeAll(all);
  } catch {
    // Quota is tight once account settings hold invoices. The photo is still
    // in the profile form and is sent with the account save.
  }
  return photo;
}
